/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityServiceAreaUploadUrlResponse
 */
export interface CreateFacilityServiceAreaUploadUrlResponse {
    /**
     * 
     */
    signed_url: string;
    /**
     * 
     */
    s3_key: string;
}

/**
 * Check if a given object implements the CreateFacilityServiceAreaUploadUrlResponse interface.
 */
export function instanceOfCreateFacilityServiceAreaUploadUrlResponse(value: object): value is CreateFacilityServiceAreaUploadUrlResponse {
    if (!('signed_url' in value) || value['signed_url'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function CreateFacilityServiceAreaUploadUrlResponseFromJSON(json: any): CreateFacilityServiceAreaUploadUrlResponse {
    return CreateFacilityServiceAreaUploadUrlResponseFromJSONTyped(json, false);
}

export function CreateFacilityServiceAreaUploadUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceAreaUploadUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'signed_url': json['signed_url'],
        's3_key': json['s3_key'],
    };
}

export function CreateFacilityServiceAreaUploadUrlResponseToJSON(json: any): CreateFacilityServiceAreaUploadUrlResponse {
    return CreateFacilityServiceAreaUploadUrlResponseToJSONTyped(json, false);
}

export function CreateFacilityServiceAreaUploadUrlResponseToJSONTyped(value?: CreateFacilityServiceAreaUploadUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signed_url': value['signed_url'],
        's3_key': value['s3_key'],
    };
}

